import { AudioEngineRemoteStreamStats } from './types'

export type AudioEngineStreamRemoteStatsSummary = {
    timestamp: Date
    pctLostAudio30sAvg: number
    pctLostAudio30sMax: number
    pctLostAudio30sMin: number
}

export class RemoteStatsSummaryBuilder {
    lastInsertedTime: number = 0

    bucketStartedTime: number = 0
    bucketData: AudioEngineRemoteStreamStats[] = []

    currSummary: AudioEngineStreamRemoteStatsSummary | null = null

    insertDataPoint(s: AudioEngineRemoteStreamStats) {
        const now = new Date().getTime()
        if (now - this.lastInsertedTime > 1000) {
            if (this.bucketStartedTime === 0 || now - this.bucketStartedTime > 30000) {
                this.summarize()

                // reset bucket
                this.bucketStartedTime = now
                this.bucketData = []
            }

            this.bucketData.push(s)
            this.lastInsertedTime = new Date().getTime()
        }
    }

    summarize() {
        if (this.bucketData.length === 0) {
            return
        }

        const pctLostAudio3s = this.bucketData.map((a) => a.pctLostAudio3s)

        const avg = pctLostAudio3s.reduce((a, b) => a + b, 0) / pctLostAudio3s.length
        const max = pctLostAudio3s.reduce((a, b) => Math.max(a, b), 0)
        const min = pctLostAudio3s.reduce((a, b) => Math.min(a, b), 100)

        this.currSummary = {
            timestamp: new Date(),
            pctLostAudio30sAvg: avg,
            pctLostAudio30sMax: max,
            pctLostAudio30sMin: min,
        }
    }
}
